<template>
  <div class="login">
    <div class="l-portrait">
      <img :src="img" />
    </div>
    <div class="l-list">
      <div :class="loginType ? 'l-input' : 'l-input-phone'">
        <label>账号</label>
        <!-- <input
          type="number"
          v-model="user.phone"
          placeholder="请输入电话号码"
        /> -->

        <input
          type="text"
          v-model="user.username"
          placeholder="请输入账号"
        />
        <!-- <countDownBtn
          v-if="!loginType"
          style="font-size: 0.22rem;"
          :title="'获取验证码'"
          @click.native="getcode"
          ref="countDown"
        >
        </countDownBtn> -->
      </div>
      <!-- <div class="l-input" v-if="!loginType">
        <label>验证码</label>
        <input type="number" v-model="user.code" placeholder="请输入验证码" />
      </div> -->
      <div class="l-input">
        <label>密码</label>
        <input
          type="password"
          v-model="user.pwd"
          placeholder="请输入密码"
        />
      </div>
      <div class="l-forgetpwd">
        <!-- <router-link to="resetpassword">忘记密码</router-link> -->
        <!-- <button @click="pwdlogin">{{ loginType | font }}</button> -->
      </div>
    </div>
    <!-- <div class="wechat" v-if="UserAgent">
      <p>使用微信登录</p>
      <button @click="getwechatloginUrl"></button>
    </div> -->
    <div class="l-btn">
      <button @click="signIn">确定</button>
    </div>
    <!-- <div class="register">
      <router-link to="/register">注册</router-link>
    </div> -->
    <copyright></copyright>
  </div>
</template>
<script>
import { getcode, getWechatOauth, WechatLogin } from '@/api/user'
import { Toast } from 'vant'
// import countDownBtn from '@/components/countDomnBtn'
import { setToken } from '@/utils/Token';
import copyright from '@/components/copyright'

import debounce from '@/utils/debounce'
import { judgeUserAgent } from '@/utils/judgeUserAgent'


export default {
  name: 'Login',
  components: {
    // countDownBtn,
    copyright
  },
  data () {
    return {
      loginType: true,
      user: {
        phone: '',
        code: '',
        pwd: '',
        username: ''
      },
      img: require('@/assets/logo.png'),
    }
  },
  computed: {
    UserAgent () {
      return judgeUserAgent('weChat')
    },
  },
  methods: {
    // 转换登录类型
    pwdlogin () {
      this.loginType ? (this.loginType = false) : (this.loginType = true)
    },
    // 获取登录微信链接
    async getwechatloginUrl () {
      const result = await getWechatOauth({ state: '/#/login' })
      if (result.data.data.status) {
        window.location.href = result.data.data.oauthUrl
      }
    },
    // 微信登录
    async loginByWechat () {
      const { wx_code } = this.$route.query;
      const result = await WechatLogin({
        code: wx_code
      })

      if (result.data.data.status) {
        const { refresh_token, token, refresh_token_expiresat, expiresat, loginInfo } = result.data.data
        const data = {
          Refresh_token: refresh_token,
          Token: token,
          Tefresh_token_expiresat: refresh_token_expiresat,
          Expiresat: expiresat,
        };
        setToken(data)

        if (!loginInfo.isBindTel) {
          this.$router.replace({
            name: 'bindTel'
          })
        } else {
          this.$router.replace({
            name: 'Home'
          })
        }
      }
    },
    // 获取验证码
    getcode: debounce(async function () {
      if (this.checkPhone()) return
      const result = await getcode({
        phone: this.user.phone,
        type: 'LOGIN_CODE',
      })
      Toast(result.data.data.message)

      if (result.data.data.status) {
        this.$refs.countDown.start()
      } else {
        this.$refs.countDown.pause()
      }
    }, 200),
    // 登录
    async signIn () {
      if (this.loginType) {
        const result = await this.$store.dispatch('user/passwordLogin', {
          phone: this.user.username,
          password: this.user.pwd,
        })
        this.signinHandle(result)
      } else {
        if (!this.checkPhone() && this.user.code !== '') {
          const result = await this.$store.dispatch('user/codeLogin', this.user)
          this.signinHandle(result)
        }

      }
    },
    // 登录处理
    signinHandle (result) {
      this.$toast(result.data.data.message)
      if (result.data.data.status) {
        this.$router.replace({
          name: 'UserInfoHandle'
        })
      }
    },
    // 号码验证
    checkPhone () {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.user.phone)) {
        this.$toast('请输入正确电话号码')
        return true
      } else {
        return false
      }
    },
  },
  filters: {
    font (value) {
      return value ? '验证码登录' : '密码登录'
    },
  },
  created () {
    const wxCode = this.$route.query.wx_code
    if (wxCode) {
      this.loginByWechat()
    }
  },

}
</script>
<style lang="scss" scoped>
$fontcolor: #999999;
.login {
  font-size: 0.15rem;
  background: #fff;
  height: 100vh;
}
input,
button {
  background: #fff;
}
.l-portrait {
  margin: auto;
  width: 3.5rem;
  height: 1.6rem;
  padding: 1rem 0;
}
.l-list {
  width: 6.35rem;
  margin: auto;
  .l-input {
    display: flex;
    justify-content: left;
    align-items: center;
    margin: 0.1rem 0;
    padding: 0.2rem 0;
    border-bottom: 1px solid #bbbbbb;
    label {
      font-size: 0.32rem;
      width: 1.75rem;
      color: #333333;
    }
    input {
      width: 2.64rem;
      font-size: 0.28rem;
      padding: 0.05rem;
      border: none;
    }
    button {
      font-size: 0.32rem;
      border: none;
      color: $fontcolor;
    }
  }
  .l-input-phone {
    @extend .l-input;
    input {
      width: 2.66rem;
    }
  }
}
.l-forgetpwd {
  a {
    color: #999999;
    font-size: 0.28rem;
    float: left;
  }
  button {
    @extend a;
    border: none;
    float: right;
  }
}
.wechat {
  text-align: center;
  margin: 1.5rem 0;
  clear: both;
  p {
    font-size: 0.32rem;
  }
  button {
    width: 0.8rem;
    height: 0.8rem;
    background: url('../../assets/icon/wechat.png') no-repeat;
    background-size: 0.79rem;
    border: none;
  }
}
.l-btn {
  text-align: center;
  margin-top: 2rem;
  button {
    width: 4.68rem;
    height: 0.99rem;
    border-radius: 30px;
    border: none;
    color: white;
    background: $globalcolor;
    font-size: 0.32rem;
  }
}
.register {
  margin: 0.2rem 0;
  text-align: center;
  a {
    width: 4.68rem;
    height: 0.99rem;
    font-size: 0.25rem;
    color: #999999;
    border-radius: 30px;
    color: white;
    background: #ffc44e;
    font-size: 0.32rem;
    display: inline-block;
    line-height: 0.99rem;
  }
}
</style>